module.exports = ( Utils, SEARCH_SCOPE ) ->
  return {

    restrict: 'A'

    template: require('./List.html')

    scope:
      getStepTemplate: '&stepTemplate'
      countries:       '='

    controller: ( $scope, $element ) ->

      # =========================
      # -------- Private --------
      # =========================

      resetFilters = ->
        $scope.filters =
          name:    undefined
          scope:   SEARCH_SCOPE.GLOBAL
          country: undefined

      isEmptyString = ( str ) ->
        str.length is 0

      getSourceCountryIds = ( source ) ->
        if source.$$type in [ 'curated', 'custom' ]
          return source.countries
        else
          return source.countries.map( ( country ) -> country.id )

      getCountryByIsoCode = ( isoCode ) ->
        return Utils.getArrayItemByFieldValue( $scope.countries, 'iso_code', isoCode )

      getInternationaCountry = ->
        return Utils.getArrayItemByFieldValue( $scope.countries, 'name', 'INTERNATIONAL' )

      internationalId = getInternationaCountry().id

      isGlobalScope = ( scope ) ->
        return scope is SEARCH_SCOPE.GLOBAL

      resetCountriesFilter = ->
        $scope.filters[ 'country' ] = undefined

      lastSelectedCountry        = getCountryByIsoCode( SEARCH_SCOPE.DEFAULT_COUNTRY_ISO_CODE_FOR_NON_GLOBAL_SCOPE )
      lastSelectedNonGlobalScope = SEARCH_SCOPE.FOCUSED

      reinstateCountriesFilter = ->
        $scope.filters[ 'country' ] = lastSelectedCountry

      # =========================
      # --------- Public --------
      # =========================

      $scope.getSourceName = ( source ) ->
        switch source.$$type
          when 'curated' then source.source.name
          when 'custom' then source.name
          when 'stepConfig' then source.name
          else 'Unknown source type'

      $scope.hasNameFilter = () ->
        nameFilter          = $scope.filters[ 'name' ]
        isNameFilterDefined = nameFilter?
        return isNameFilterDefined and not isEmptyString( nameFilter )

      $scope.hasCountryFilter = () ->
        countryFilter          = $scope.filters[ 'country' ]
        isCountryFilterDefined = countryFilter?
        return isCountryFilterDefined

      $scope.setCountriesFilter = ( country ) ->
        if country?
          lastSelectedCountry = country
          $scope.filters.scope = lastSelectedNonGlobalScope
        else
          $scope.filters.scope = SEARCH_SCOPE.GLOBAL

        $scope.filters[ 'country' ] = country

      $scope.sourceFilter = ( source ) ->
        countryMatch = true
        nameMatch    = true

        if $scope.hasCountryFilter()
          sourceCountryIds = getSourceCountryIds( source )

          isSourceAssociatedWithCountry = ( country ) ->
            return country.id in sourceCountryIds

          isSourceInternational = () ->
            return internationalId in sourceCountryIds

          includeInternationalSources = () ->
            return $scope.filters.scope is SEARCH_SCOPE.ENHANCED

          country = $scope.filters[ 'country' ]
          countryMatch = isSourceAssociatedWithCountry( country )

          if includeInternationalSources()
            countryMatch = countryMatch or isSourceInternational()

        if $scope.hasNameFilter()
          nameFilter = ( $scope.filters[ 'name' ] ).toLowerCase()
          sourceName = ( $scope.getSourceName( source ) ).toLowerCase()
          nameMatch  = sourceName.indexOf( nameFilter ) != -1

        keep = nameMatch and countryMatch
        return keep

      $scope.onScopeFilterChange = ( scope ) ->
        # when scopeSelector changes its state, it calls this method
        # and also changes $scope.selector.scope through 2-way-data-binding
        # that didnt fires sometimes. So we will change it here as well
        $scope.filters.scope = scope
        if isGlobalScope( scope )
          resetCountriesFilter()
        else
          lastSelectedNonGlobalScope = scope
          reinstateCountriesFilter()


      # =========================
      # ---- Initialisation -----
      # =========================

      resetFilters()

      $scope.$watchCollection (->
        $scope.getStepTemplate().getSources()
      ), ( sources ) ->
        resetFilters()
        return

      return
  }
